const $ = require('jquery');
// require('web/jquery.faq');
// shimované pluginy většinou nemají export, většinou extendují jQuery object
require('./web/highslide-settings');
require('./web/formFloatingLabels');
require('fg-frontend/plugins/jquery.universal-pagination');
require('bootstrap/tooltip');
require('fg-frontend/third/jquery.cookie');
require('jquery-unveil');
require('picturefill');
require('./web/svg4everybody');
require('./localization/locale');
// require('./web/jquery.rowHeight');
// require('./web/jquery.cookies-policy');
require('./web/slick/slick');
require('./web/twoComponentPriceCalculator');
const PhoneLinkActivation = require('./web/phoneLinkActivation');

require('./web/typeahead.bundle');
const Bloodhound = require('./web/bloodhound');

import './web/Typeahead';

/**
 * SVG For Everybody
 * - přidává podporu SVG pro externí obsah do všech prohlížečů.
 */
svg4everybody();

/**
 * TWO COMPONENT PRICE CALCULATOR
 */
$(() => {
  const calculator = $('#priceCalculator');
  if (calculator.length > 0) {
    calculator.twoComponentPriceCalculator();
  }
});

/**
 * Page slider
 */
$(() => {
  const pageSlider = $('.page-slider');
  const pageSliderMotive = $('.page-slider-motive');
  if (pageSlider.length > 0) {
    pageSlider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      asNavFor: '.page-slider-motive',
      focusOnSelect: true,
    });
  }
  if (pageSliderMotive.length > 0) {
    pageSliderMotive.slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  fade: true,
		  asNavFor: '.page-slider',
    });
  }
});

/**
 * Promění definovaný selektor (span.phone-number je default, z této definice je možné smazat) v odkazy s telefonním číslem.
 * Pouze na mobilních telefonech. Automaticky se mění i po přidání do DOMu. Pokud z nějakého důvodu nefunguje,
 * je možné pořešit pomocí phoneLink.getRelevantElements()
 */
const phoneLink = new PhoneLinkActivation(document.body, {
  selector: 'span.phone-number',		// vymezit selektor, kde chceme použít transformaci čísla na odkaz
  linkClassName: 'phone-number',		// třída, která bude vložena na výsledný odkaz (kvůli případnému stylování)
  domChange: true,						// flag, zda chceme měnit čísla on the fly i po změně DOMu.
  // Pokud ne, phoneLink.getRelevantElements()
});
// window.phoneLink = phoneLink;		// toto není nutné zapínat, pokud nepotřebujeme manuálně volat změnu


function externalLinks() {
  /* nastavení­ textu a ikony k externím odkazům */
  const projectDomain = document.domain;
  const domain = `a[href^="http"]:not([href^="http://${projectDomain}"]), a[href^="https"]:not([href^="https://${projectDomain}"], a[href^="//"]:not([href^="//${projectDomain}"])`;
  /* Přidání target="blank" a rel="noopener s noreferrer" */
  $(domain).each(function () {
    $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
  });
}

$(document).on('click', '.js_show-menu', function (e) {
  e.preventDefault();
  $('.menu-burger__text', this).toggleText('toggle-text');
  $(this).toggleClass('menu-burger--close');
  $('#navigation').toggleClass('navigation--show');
  $('.submenu').removeClass('submenu--show');
  $('.main-menu__link').removeClass('main-menu__link--active');
  // $($(this).data('target')).toggleClass('mainMenu--show');
});

$(document).on('click', '.js_show-phone-contact', (e) => {
  const $infoLine = $('#info-line');

  e.preventDefault();
  $infoLine.addClass('info-line--show');
  $infoLine.append('<a class="btn btn--gray btn--icon info-line__close js_close-phone-contact"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#close"></use></svg><span class="sr-only">zavřít</span></a>');
  $('.info-line__phone', $infoLine).prepend('<svg class="info-line__svg-icon svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#phone"></use></svg>');
  $('body').css('overflow-y', 'hidden');
});


$(document).on('click', '.js_close-phone-contact', (e) => {
  const $infoLine = $('#info-line');

  e.preventDefault();
  $infoLine.removeClass('info-line--show');
  $('.js_close-phone-contact', $infoLine).remove();
  $('.info-line__phone .info-line__svg-icon', $infoLine).remove();
  $('body').css('overflow-y', 'auto');
});

$(document).on('click', '.js_show-accounts', function (e) {
  e.preventDefault();
  $(this).toggleClass('menu-bar__link--account-active');
  $('#account-login').toggleClass('account-login--show');
});

$(document).on('click', '.navigation--show .main-menu__item--has-descendant .main-menu__link', function (e) {
  const $parent = $(this).parent();
  e.preventDefault();
  $(this).toggleClass('main-menu__link--active');
  // $('.submenu').removeClass('submenu--show');
  $('.submenu', $parent).toggleClass('submenu--show');
});

/* odstranění vlastnosti style */
$('*[style]').removeAttr('style');

/* změny hlavičky podle RWD */
const changeHeader = function () {
  const init = function () {
    let resizeTimer;


    let scrolled = true;
    const containerHeightSmall = 65;
    const containerHeightBig = 160;
    let containerHeight;

    if (window.innerWidth >= 1200) {
      changeToDesktop();
      containerHeight = containerHeightBig;
      changeToSticky(scrolled, containerHeight);
    }
    // else {
    // 	containerHeight = containerHeightSmall;
    // }

    $(window).on('resize', (e) => {
      if ($('input').is(':focus')) {
        // nedelej nic!
      } else {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (window.pageYOffset >= containerHeight && scrolled) {
            changeToSticky(false, containerHeight);
            scrolled = false;
          } else {
            changeToSticky(true, containerHeight);
          }

          if (window.innerWidth >= 1200) {
            changeToDesktop();
          } else {
            changeToMobile();
          }
        }, 250);
      }
    });

    $(window).on('scroll', (e) => {
      clearTimeout(resizeTimer);
      if (window.innerWidth >= 1200) {
        resizeTimer = setTimeout(() => {
          if (window.pageYOffset >= containerHeight && scrolled) {
            changeToSticky(false, containerHeight);
            scrolled = false;
          }
          if (window.pageYOffset < containerHeight && !scrolled) {
            changeToSticky(true, containerHeight);
            scrolled = true;
          }
        }, 250);
      }
    });
  };

  var changeToDesktop = function () {
    $('#form-search').detach().appendTo('#desktop-header-1');
    $('#languages').detach().appendTo('#desktop-header-1');
    $('#info-line').detach().appendTo('#desktop-header-2');
    $('#account').detach().appendTo('#desktop-header-2');
    $('#village').detach().appendTo('#desktop-header-2');

    $('.menu-burger__text').text($('.menu-burger__text').data('toggle-text'));
    $('.js_show-menu').removeClass('menu-burger--close');
    $('#navigation').removeClass('navigation--show');
    $('.submenu').removeClass('submenu--show');
  };

  var changeToMobile = function () {
    $('#account').detach().insertAfter('#phone-contact');
    $('#info-line').detach().insertAfter('#phone-contact');
    $('#form-search').detach().insertBefore('#main-menu');
    $('#village').detach().insertBefore('#main-menu');
    $('#languages').detach().insertAfter('#main-menu');
  };

  /**
	 * Sticky Menu
	 */
  var changeToSticky = function (scrolled) {
    // bottom
    if (!scrolled) {
      $('#page-header-bottom').detach().appendTo('#page-header-sticky');
      $('#desktop-header-2').detach().insertAfter('#menu-bar');
      $('.page-headline').css('margin-top', '91px');
      var logo = $('.page-header').find('.logo__image');
      const logoSmall = logo.attr('src');
      logo.attr('src', logo.attr('data-small-src'));
      logo.attr('data-small-src', logoSmall);

      $('.page-header__sticky').animate({ top: '0px' });
    }
    // top
    if (scrolled) {
      $('#page-header-bottom').detach().insertAfter('#page-header-top');
      $('#desktop-header-2').detach().insertAfter('#desktop-header-1');
      $('.page-headline').css('margin-top', '0px');
      var logo = $('.page-header').find('.logo__image');
      if (logo.length > 0) {
        if (logo.attr('src').indexOf('ico-kruh') > -1) {
          const logoBig = logo.attr('data-small-src');
          logo.attr('data-small-src', logo.attr('src'));
          logo.attr('src', logoBig);
        }
      }
      $('.page-header__sticky').animate({ top: '-65px' });
    }
  };

  init();
};

changeHeader();


/** ******************************************
 * stage list pagination
 ****************************************** */
$(document).on('STAGE_PAGINATION_ACTIVATE', () => {
  $('.js_pagination-stage').each((index, item) => {
    const $page = $(item);
    $page.universalPagination({
      listSelector: '.js_psList',
      itemSelector: '.js_psItem',
      lang: web.lang,
      nextClass: 'btn',
      nextWrapperClass: 'buttons buttons--center',
      autoPreloadHistory: false,
      listTopOffset: 15,
      paginationSelector: '.js_pagination-stage',
      wrapperClass: 'pagination__wrapper',
    });
  });
}).on('ajaxComplete', () => {
  $(document).trigger('STAGE_PAGINATION_ACTIVATE');
});
$(document).trigger('STAGE_PAGINATION_ACTIVATE');

$.fn.toggleText = function (dataId) {
  const newText = $(this).data(dataId);
  $(this).data(dataId, $(this).text());
  $(this).text(newText);
};

$('.js_info-panel-close').on('click', function (e) {
  this.parentElement.style.display = 'none';
});

if ($('.js_map-filter').length) {
  $('.js_map-filter').ready(() => {
    $(window).on('load resize', () => {
      if (window.innerWidth < 768) {
        document.getElementById('map-filter').classList.add('map-filter--hide');
      } else {
        document.getElementById('map-filter').classList.remove('map-filter--hide');
      }
    });
  });
}

$('.js_scroll-to-odstavky-a-havarie').click(function (e) {
  const destination = $(this).attr('href');
  e.preventDefault();
  if (!$(destination).hasClass('accordion__active')) {
    $(destination).click();
  }
  scrollToElement(destination);
});


$('.js-main-menu').ready(() => {
  $('.main-menu__link').on('mouseover', () => {
    $('.main-menu__item .main-menu__link').blur();
  });
});

function scrollToElement(destination) {
  $('html, body').animate({
    scrollTop: $(destination).offset().top,
  }, 500);
}

$(document).on('click', '.js_map-filter', function (e) {
  e.preventDefault();
  this.parentElement.classList.toggle('map-filter--hide');
});

// FAQ - Accordion
function scrollToElementAcc(elementId) {
  const element = document.getElementById(elementId);
  let topOffset = 15;
  if (window.innerWidth >= 1200) {
    topOffset = 80;
  }
  if (element != null) {
    const elHeader = element.querySelector('.accordion__header');
    const elementOffsetTop = element.getBoundingClientRect().top + window.pageYOffset - topOffset;
    window.scroll({
      top: elementOffsetTop, // could be negative value
      left: 0,
      behavior: 'smooth',
    });
    $(elHeader).trigger('click');
  }
}

$('.accordion').ready(() => {
  const hashId = window.location.hash.substr(1);
  if (hashId !== '') {
    setTimeout(() => {
      scrollToElementAcc(hashId);
    }, 300);
  }
  const accItem = document.getElementsByClassName('accordion__header');
  let i,
    accLast,
    isActive;

  for (i = 0; i < accItem.length; i++) {
    accItem[i].onclick = (function (i) {
      return function () {
        if (!isAccordionActive(i)) {
          if (accLast) {
            showAccordionContent(accLast);
          }
          showAccordionContent(this);
          accLast = this;
        } else {
          showAccordionContent(this);
          accLast = '';
        }
      };
    }(i));
  }

  var showAccordionContent = function (element) {
    $(element).find('.accordion-arrow__svg-icon').toggleClass('accordion-arrow__svg-icon--reverse');
    $(element).toggleClass('accordion__active');
    $(element).siblings().toggleClass('accordion__show');
  };

  var isAccordionActive = function (i) {
    return isActive = accItem[i].classList.contains('accordion__active');
  };
});


// safe blank link
$('a[target="_blank"]:not([rel="noopener"])').each(function () {
  $(this).attr('rel', 'noopener');
});


$(() => {
  /* inicialized bootstrap tooltip */
  /* $('[rel="tooltip"]').tooltip({placement : 'bottom'}); */
  $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();

  /* initialization lazy loading */
  // $('.photogallery img, .list-news .motive, .lazyloading').unveil(150);
  $('.photogallery img, .lazyloading').unveil(150);

  // odkaz zpet
  $('.js_history-back').click(() => {
    if (document.referrer.indexOf(document.domain) > -1) {
      location.href = document.referrer;
      return false;
    }
  });

  $('#planedOutagesSelect').change(function () {
    $('.planedOutagesList li').show();
    if ($(this).val() == '1') {
      $('.planedOutagesList li:not(.in-progress)').hide();
    } else if ($(this).val() == '2') {
      $('.planedOutagesList li.in-progress').hide();
    }
  });

  $('.planedOutagesList .showMore').click(function (e) {
    e.preventDefault();
    $($(this).attr('href')).toggleClass('hide');
    $(this).toggleText('toggle-text');
  });

  if ($('.js_selectDocumentType').length && $('#selectDocumentType').length) {
    let fileType = $('#selectDocumentType option:selected').val();

    $('.js_selectDocumentType .attachments__item').each(function () {
      $(this).not(`[data-file-type=${fileType}]`).hide();
    });

    $('#selectDocumentType').on('change', () => {
      // fileType = $('#selectDocumentType').val();
      console.log('change');
      console.log($('#selectDocumentType option:selected').val());
      fileType = $('#selectDocumentType option:selected').val();
      $('.js_selectDocumentType .attachments__item').each(function () {
        $(this).show();
        $(this).not(`[data-file-type=${fileType}]`).hide();
      });
    });
  }
  $(`.cityPartDocuments .list-files li:not(.type-${$('#selectDocumentType option:first').attr('value')})`).hide();

  $('#selectDocumentType').change(function () {
    const $fileList = $(this).parents('div.widget').find('.list-files');
    $('li', $fileList).hide();
    $(`.type-${$(this).val()}`, $fileList).show();
  });

  $('.phoneFormat').each(function () {
    $(this).html(`<span class="phone-number">${phoneToTelLinks($(this).text())}</span>`);
  });

  $('.openingHours').each(function () {
    $(this).html(formatOpeningHours($(this).text()));
  });

  $('body').on('click', '.localPartDetailLink', function (e) {
    e.preventDefault();
    $.cookie('localPartId', $(this).attr('data-local-part-id'), { expires: 365, path: '/' });
    window.location = $(this).attr('href');
  });

  $.fn.handleProductPagination = function () {
    this.each(function () {
      const $nextPageLink = $('li:last a', this);
      if ($nextPageLink.length == 1) {
        let nextLink = $nextPageLink.attr('href');
        const $nextPageObject = $('<div class="buttons buttons--center"><a href="#" class="btn">Zobrazit další</a></div>');
        $(this).replaceWith($nextPageObject);
        $nextPageObject.click((e) => {
          e.preventDefault();
          $.get(nextLink, (htmlResult) => {
            // uchovani pozice scrollu pred vlozenim radku, aby prohlizec (scroll anchoring)
            // neodscroloval na tlacitko a nove polozky zustaly viditelne
            const scrollTop = $(window).scrollTop();
            history.pushState(null, null, nextLink);
            const $htmlResult = $(htmlResult);
            const $nextLinkObject = $htmlResult.find('.pagination li:last a');
            const $newRows = $htmlResult.find('.cityLocalPartListTable tbody>tr');
            const $firstNewRow = $newRows.first();
            $('.cityLocalPartListTable tbody').append($newRows);
            $(window).scrollTop(scrollTop);
            // odscrolovani na prvni novou polozku tesne pod sticky header (offset 75px)
            // if ($firstNewRow.length) {
            //   $('html, body').stop().animate({
            //     scrollTop: $firstNewRow.offset().top - 75
            //   }, 500);
            // }
            if ($nextLinkObject.length == 1) {
              nextLink = $nextLinkObject.attr('href');
            } else {
              $nextPageObject.remove();
            }
          });
        });
      } else {
        $(this).remove();
      }
    });
  };

  // zpet na seznam obci s vymazanim cookie
  $('.removeCPCookie').click(() => {
    $.cookie('localPartId', null, { path: '/' });
  });

  externalLinks();
  initCevakPhoneLines();

  // prebarveni formulare v tmavem boxu

  if ($('.js_form-search-dark').length) {
    $('.js_form-search-dark').ready(() => {
      $(window).on('load resize', () => {
        console.log(document.body.clientWidth);
        if (window.innerWidth < 1200) {
          $('.js_form-search-dark').find('.search-box').removeClass('search-box--dark').find('.btn')
            .removeClass('btn--red');
        } else {
          $('.js_form-search-dark').find('.search-box').addClass('search-box--dark').find('.btn')
            .removeClass('btn--red');
        }
      });
    });
  }

  $('.js_tab').ready(() => {
    const tabLink = document.getElementsByClassName('tab__link');

    for (let i = 0; i < tabLink.length; i++) {
      if (tabLink[i].classList.contains('tab__link--active')) {
        document.getElementById(tabLink[i].getAttribute('data-tab-id')).style.display = 'block';
      }
      tabLink[i].addEventListener('click', function () {
        hideAllTab();
        this.classList.add('tab__link--active');
        const tabId = this.getAttribute('data-tab-id');
        document.getElementById(tabId).style.display = 'block';
      });
    }
  });

  $('.js_tabSelect').each(function () {
    const currentTab = $(this).val();
    document.getElementById(currentTab).style.display = 'block';

    $(this).on('change', function () {
      hideAllTab();
      const tabId = $(this).val();
      document.getElementById(tabId).style.display = 'block';
    });
  });

  function hideAllTab() {
    const tabItem = document.getElementsByClassName('tab__item');
    for (var i = 0; i < tabItem.length; i++) {
      tabItem[i].style.display = 'none';
    }

    const tabLink = document.getElementsByClassName('tab__link');
    for (var i = 0; i < tabLink.length; i++) {
      tabLink[i].classList.remove('tab__link--active');
    }
  }
});

// setClaimOffset();

function formatPhoneNumber(phoneNumber, addPrefix) {
  addPrefix = typeof addPrefix !== 'undefined' ? addPrefix : true;
  let result = '';
  if (phoneNumber != '') {
    const phoneNumberArr = phoneNumber.split(',');
    let value = '';
    let resultStr = '';
    for (let i = 0; i < phoneNumberArr.length; i++) {
      value = phoneNumberArr[i].trim();
      value = value.replace(/ /g, '').replace('+420', '');
      resultStr = `${value.substr(-9, 3)} ${value.substr(-6, 3)} ${value.substr(-3, 3)}`;
      if (value.length > 9) {
        resultStr = value.substr(0, value.length - 9) + resultStr;
      }
      if (addPrefix) {
        resultStr = `+420 ${resultStr}`;
      }
      if ((i + 1) < phoneNumberArr.length) {
        resultStr = `${resultStr}<br/>`;
      }
      result += resultStr;
    }
  }
  return result;
}

// Naformátuje telefonní číslo (příp. čárkou oddělený seznam) a obalí do tel: odkazu.
// Zobrazený text respektuje addPrefix, href má vždy plný tvar s předvolbou +420.
function phoneToTelLinks(phoneNumber, addPrefix) {
  addPrefix = typeof addPrefix !== 'undefined' ? addPrefix : true;
  if (phoneNumber == null || phoneNumber === '') {
    return '';
  }
  const parts = phoneNumber.split(',');
  const links = [];
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].trim() === '') {
      continue;
    }
    const display = formatPhoneNumber(parts[i], addPrefix);
    const href = `tel:${formatPhoneNumber(parts[i], true).replace(/\s/g, '')}`;
    links.push(`<a class="phone-number__link" href="${href}">${display}</a>`);
  }
  return links.join('<br/>');
}

function formatOpeningHours(openingHours) {
  if (openingHours != '') {
    return openingHours.replace(/;/g, '<br/>');
  }
  return '';
}

function initCevakPhoneLines() {
  const afNumber = computeActualPhoneNumber(phoneNumbers_af_phone, phoneHolidays_af_phone, phoneDefault_af_phone);
  const csNumber = computeActualPhoneNumber(phoneNumbers_cs_phone, phoneHolidays_cs_phone, phoneDefault_cs_phone);
  if (afNumber != '') {
    // $('#globalAFPhoneNumber').html('<span class="icon icon-phone"><span class="phone-number">'+formatPhoneNumber(afNumber, false)+'</span></span>');
    $('#contactsAFPhoneNumber').html(`<span class="icon icon-phone"><span class="phone-number">${phoneToTelLinks(afNumber, false)}</span></span>`);
    $('#hpAFPhoneNumber').html(`<span class="icon icon-phone"><span class="phone-number">${phoneToTelLinks(afNumber, false)}</span></span>`);
    $('#cityPartAccidentNumber').html(`<span class="icon icon-phone"><span class="phone-number">${phoneToTelLinks(afNumber)}</span></span>`);
    $('.js_phone-accidents-info').html(`<span class="info-line__phone"><span class="phone-number">${phoneToTelLinks(afNumber, false)}</span></span>`);
    $('.js_phone-accidents-accident').html(`<span class="info-line__phone"><span class="phone-number">${phoneToTelLinks(afNumber, false)}</span></span>`);
    $('.js_phone-accidents').html(`<span class="phone-number">${phoneToTelLinks(afNumber, false)}</span>`);
  } else {
    // $('#globalAFPhoneNumber').parent('p').remove();
    $('.js_phone-accidents-info').parent().remove();
    $('.js_phone-accidents').parents('.footer-contact-bar__item').remove();
    $('.js_phone-accidents-accident').parents('.contact-accident').remove();
    // $('.js_phone-accidents').parent().remove();
  }
  if (csNumber != '') {
    // $('#globalCSPhoneNumber').html('<span class="icon icon-phone"><span class="phone-number">'+formatPhoneNumber(csNumber, false)+'</span></span>');
    $('#contactsCSPhoneNumber').html(`<span class="icon icon-phone"><span class="phone-number">${phoneToTelLinks(csNumber, false)}</span></span>`);
    $('.js_phone-customer-line-info').html(`<span class="info-line__phone"><span class="phone-number">${phoneToTelLinks(csNumber, false)}</span></span>`);
    $('.js_phone-customer-line-accident').html(`<span class="info-line__phone"><span class="phone-number">${phoneToTelLinks(csNumber, false)}</span></span>`);
    $('.js_phone-customer-line').html(`<span class="phone-number">${phoneToTelLinks(csNumber, false)}</span>`);
    // $('#contactsCSPhoneNumber').parents('.widget').show();
  } else {
    // $('#globalCSPhoneNumber').parent('p').remove();
    $('#contactsCSPhoneNumber').parents('.widget').remove();
    $('.js_phone-customer-line-info').parent().remove();
    $('.js_phone-customer-line').parents('.footer-contact-bar__item').remove();
    $('.js_phone-customer-line-accident').parents('.contact-accident').remove();
    // $('.js_phone-customer-line').parent().remove();
  }
}

function computeActualPhoneNumber(phoneNumbers, holidays, defaultPhone) {
  let line,
    lineTimes;
  const actualTimeInt = convertTimeToInt(csPhoneActualTime);
  const phoneNumberArr = phoneNumbers.split('@');
  const actualDateNoYear = csPhoneActualDate.substring(0, csPhoneActualDate.lastIndexOf('.') + 1);

  if (phoneNumbers != '') {
    if (holidays != '' && ($.inArray(csPhoneActualDate, holidays.split(';')) > -1 || $.inArray(actualDateNoYear, holidays.split(';')) > -1)) {
      for (var key in phoneNumberArr) {
        line = phoneNumberArr[key].split(';');
        lineTimes = line[2].split('-');
        if ($.inArray('0', line[1].split(',')) > -1 && convertTimeToInt(lineTimes[0]) <= actualTimeInt && convertTimeToInt(lineTimes[1]) >= actualTimeInt) {
          return line[0];
        }
      }
    } else {
      for (var key in phoneNumberArr) {
        line = phoneNumberArr[key].split(';');
        lineTimes = line[2].split('-');
        if ($.inArray(csPhoneActualDayInWeek, line[1].split(',')) > -1 && convertTimeToInt(lineTimes[0]) <= actualTimeInt && convertTimeToInt(lineTimes[1]) >= actualTimeInt) {
          return line[0];
        }
      }
    }
  }


  if (defaultPhone != '') {
    return defaultPhone;
  }
 	return '';
}

function convertTimeToInt(time) {
  return parseInt(time.replace(':', ''));
}

$('.map-legend').each(function () {
  const $t = $(this);
  $('.control', $t).on('click', function () {
    const pageMotiveHeight = $('.page-motive').outerHeight(true);
    const mapLegendHeight = $(this).outerHeight(true);
    let newPageMotiveHeight;

    $(this).toggleClass('icon-map-legend-open').toggleClass('icon-map-legend-close');
    // $('.wrapper', $t).slideToggle(500, function() {
    $('.wrapper', $t).toggle(0, function () {
      if ($(this).is(':visible')) {
        newPageMotiveHeight = pageMotiveHeight + $(this).outerHeight(true);
      } else {
        newPageMotiveHeight = pageMotiveHeight - $(this).outerHeight(true);
      }
      $('.page-motive').outerHeight(newPageMotiveHeight);
    });
  });
});

if ($('#main').length) {
  // Najdeme všechny elementy s třídou "bg-bubble"
  const elements = document.querySelectorAll('.bg-bubble');

  // Projdeme všechny nalezené elementy
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];

    // Zkontrolujeme, zda je index lichý nebo sudý
    if (i % 2 === 0) {
      // Index je sudý, přidáme třídu "bg-bubble--odd"
      element.classList.add('bg-bubble--odd');
    } else {
      // Index je lichý, přidáme třídu "bg-bubble--even"
      element.classList.add('bg-bubble--even');
    }
  }
}

const benefitsListContent = function () {
  const $block = $('.js_benefits');
  const countElements = $block.children().length;
  let currentBenefit = 0;

  const init = function () {
    $('.benefits__cta', $block).on('click', function () {
      const $item = $(this).closest('.benefits__item');
      currentBenefit = $item.index();
      showBenefitsDetail($item, currentBenefit);
    });

    $('.js_modalBenefitsArrow.modal__arrow--previous').on('click', () => {
      changeBenefit('-1');
    });

    $('.js_modalBenefitsArrow.modal__arrow--next').on('click', () => {
      changeBenefit('+1');
    });
  };

  const showBenefitsDetail = function ($item, index) {
    const $modalContent = $item.find('.benefits__modal').first().clone();
    $modalContent.find('.benefits__content').removeClass('sr-only');
    $('#modalBenefits .modal__content').html($modalContent.html());
    $('.modal__counter').html(`${index + 1}/${countElements}`);
  };

  const changeBenefit = function (direction) {
    let newBenefit = currentBenefit;

    if (direction === '+1') {
      newBenefit = (newBenefit + 1) % countElements;
    } else if (direction === '-1') {
      newBenefit = (newBenefit - 1 + countElements) % countElements;
    }

    const $item = $block.children().eq(newBenefit);
    const $modalContent = $item.find('.benefits__modal').first().clone();
    $modalContent.find('.benefits__content').removeClass('sr-only');
    $('#modalBenefits .modal__content').html($modalContent.html());
    $('.modal__counter').html(`${newBenefit + 1}/${countElements}`);

    currentBenefit = newBenefit;
  };

  init();
};

if ($('.js_benefits').length) {
  benefitsListContent();
}

if (document.querySelector('.vacanty-list-hp')) {
  const items = document.querySelectorAll('.vacanty-list-hp__item');

  items.forEach((item) => {
    const linkElements = item.querySelectorAll('.js_vacanty-list-hp__link');
    const headerElement = item.querySelector('.vacanty-list-hp__header');

    linkElements.forEach((linkElement) => {
      linkElement.addEventListener('mouseover', () => {
        headerElement.classList.add('vacanty-list-hp__header--active');
      });

      linkElement.addEventListener('mouseout', () => {
        headerElement.classList.remove('vacanty-list-hp__header--active');
      });

      linkElement.addEventListener('focus', () => {
        headerElement.classList.add('vacanty-list-hp__header--active');
      });

      linkElement.addEventListener('blur', () => {
        headerElement.classList.remove('vacanty-list-hp__header--active');
      });
    });
  });
}

if (document.querySelector('.benefits')) {
  const items = document.querySelectorAll('.benefits__item');

  items.forEach((item) => {
    const linkElement = item.querySelector('.benefits__cta');
    const headerElement = item.querySelector('.benefits__image');

    linkElement.addEventListener('mouseover', () => {
      headerElement.classList.add('benefits__image--active');
    });

    linkElement.addEventListener('mouseout', () => {
      headerElement.classList.remove('benefits__image--active');
    });

    linkElement.addEventListener('focus', () => {
      headerElement.classList.add('benefits__image--active');
    });

    linkElement.addEventListener('blur', () => {
      headerElement.classList.remove('benefits__image--active');
    });
  });
}

$(() => {
  const corporateMessageSlider = $('.corporate-message');
  if (corporateMessageSlider.length > 0) {
    corporateMessageSlider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 10000,
      slidesToShow: 1,
    });
  }


  const getToKnowSlider = $('.get-to-know');
  if (getToKnowSlider.length > 0) {
    getToKnowSlider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 10000,
      slidesToShow: 1,
    });
  }
});

document.addEventListener('click', (event) => {
  const target = event.target.closest('#openSendCvBtn');
  if (!target) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'button',
    button: {
      name: 'Tlačítko',
      spec: target.textContent.trim(),
      url: window.location.href,
    },
    _clear: true,
  });
});

document.addEventListener('click', (event) => {
  const target = event.target.closest('.contact__link, #openStillLookingBtn');
  if (!target) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'button',
    button: {
      name: 'Tlačítko - Máte zájem? Napište nám',
      spec: target.textContent.trim(),
      url: window.location.href,
    },
    _clear: true,
  });
});

/*
$(function(){
	$('body').cookiesPolicy({
		lang: web.lang || 'cs',
		position: 'bottom',
		css: {
			brandColor: '#568fa4',
			panel: {
				'position': 'fixed',
				'color': '#0a2b3b',
				'background-color': 'rgba(255,255,255,0.95)',
				'padding-top': '1em',
				'padding-bottom': '1em',
				'z-index': 5000,
				'width': '100%',
				'font-size': '1.6rem',
				'line-height': '2.6rem'
			},
			button: {
				'color': '#568fa4',
				'display': 'inline-block',
				'margin-right': '10px',
				'padding': '0.3em 1em'
			},
			buttonHighlighted: {
				'color': '#fff',
				'background-color': '#32799c',
				'border': '1px solid transparent',
				'border-color': 'transparent',
				'border-radius': '0',
				'display': 'inline-block',
				'margin-right': '1rem',
				'text-decoration': 'none',
				'padding': '0.5em 1.2em'
			},
		},
		messages: {
			'cs': {link: '/cs/informace-o-webu#cookies'}
		}
	});
});
*/

if (window.navigator.msPointerEnabled) {
  $('body').addClass('ie11');
}


$.each(q, (index, f) => {
  $(f);
});




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js